<div class="activity-bar" role="toolbar" aria-label="Ações" aria-orientation="vertical">
  <button
    type="button"
    class="activity-button"
    tabindex="0"
    appTooltip="Executar"
    appTooltipShortcut="Ctrl+Enter"
    appTooltipPosition="right"
    aria-label="Executar"
    aria-keyshortcuts="Control+Enter"
    [attr.aria-disabled]="!canRun() || null"
    (click)="canRun() && runCode('editor')"
  >
    <svg-icon src="assets/icon-start.svg" class="icon-green" aria-hidden="true" />
  </button>

  <button
    type="button"
    class="activity-button"
    tabindex="-1"
    appTooltip="Parar"
    appTooltipShortcut="Shift+F5"
    appTooltipPosition="right"
    aria-label="Parar"
    aria-keyshortcuts="Shift+F5"
    [attr.aria-disabled]="!canStop() || null"
    (click)="canStop() && stopCode('editor')"
  >
    <svg-icon src="assets/mdi/square-rounded-outline.svg" class="icon-red" aria-hidden="true" />
  </button>

  @let stepping = basicStepping();
  <button
    type="button"
    class="activity-button debug-button"
    tabindex="-1"
    appTooltipShortcut="Alt+P"
    appTooltipPosition="right"
    aria-keyshortcuts="Alt+P"
    [appTooltip]="stepping ? 'Próximo passo' : 'Depurar (passo a passo)'"
    [attr.aria-label]="stepping ? 'Próximo passo' : 'Depurar'"
    [attr.aria-disabled]="(stepping ? !paused() : !canRun()) || null"
    (click)="(stepping || !debugging) && onDebugButton('editor')"
  >
    <svg-icon
      aria-hidden="true"
      [src]="stepping ? 'assets/mdi/debug-step-into.svg' : 'assets/mdi/bug-play-outline.svg'"
      [class]="stepping ? 'icon-blue' : 'icon-green'"
    />
  </button>

  <span class="activity-separator" role="separator"></span>

  <button
    type="button"
    class="activity-button"
    tabindex="-1"
    appTooltip="Abrir arquivo"
    appTooltipShortcut="Ctrl+O"
    appTooltipPosition="right"
    aria-label="Abrir arquivo"
    aria-keyshortcuts="Control+O"
    (click)="openFile.emit('editor')"
  >
    <svg-icon src="assets/mdi/folder-open-outline.svg" class="icon-yellow" aria-hidden="true" />
  </button>

  <button
    type="button"
    class="activity-button"
    tabindex="-1"
    appTooltip="Salvar"
    appTooltipShortcut="Ctrl+S"
    appTooltipPosition="right"
    aria-label="Salvar"
    aria-keyshortcuts="Control+S"
    (click)="saveFromEditor('editor')"
  >
    <svg-icon src="assets/mdi/content-save-outline.svg" class="icon-blue" aria-hidden="true" />
  </button>

  <button
    type="button"
    class="activity-button"
    tabindex="-1"
    appTooltip="Salvar como…"
    appTooltipPosition="right"
    aria-label="Salvar como"
    gaEvent="editor_save_as"
    gaCategory="Editor"
    gaLabel="Botão de Salvar como"
    [cdkMenuTriggerFor]="saveMenu"
    [cdkMenuPosition]="menuPositions"
  >
    <svg-icon src="assets/mdi/content-save-settings-outline.svg" class="icon-blue" aria-hidden="true" />
  </button>

  <button
    type="button"
    class="activity-button"
    tabindex="-1"
    appTooltip="Compartilhar código"
    appTooltipPosition="right"
    aria-label="Compartilhar código"
    [attr.aria-disabled]="sharing || null"
    (click)="!sharing && shareFile()"
  >
    <svg-icon src="assets/mdi/share-variant-outline.svg" class="icon-green" aria-hidden="true" />
  </button>

  <span class="activity-separator" role="separator"></span>

  <button
    type="button"
    class="activity-button"
    tabindex="-1"
    appTooltip="Abrir exemplo"
    appTooltipPosition="right"
    aria-label="Abrir exemplo"
    (click)="examples.emit()"
  >
    <svg-icon src="assets/mdi/book-open-page-variant-outline.svg" class="icon-yellow" aria-hidden="true" />
  </button>

  <button
    type="button"
    class="activity-button"
    tabindex="-1"
    appTooltip="Ajuda"
    appTooltipShortcut="F1"
    appTooltipPosition="right"
    aria-label="Ajuda"
    aria-keyshortcuts="F1"
    (click)="openHelp('editor')"
  >
    <svg-icon src="assets/mdi/help-circle-outline.svg" class="icon-blue" aria-hidden="true" />
  </button>

  <span class="activity-spacer"></span>

  <button
    type="button"
    class="activity-button"
    tabindex="-1"
    appTooltip="Configurações"
    appTooltipPosition="right"
    aria-label="Configurações"
    (click)="openSettings()"
  >
    <svg-icon src="assets/mdi/cog-outline.svg" class="icon-yellow" aria-hidden="true" />
  </button>
</div>

<ng-template #saveMenu>
  <div class="menu" cdkMenu aria-label="Salvar como">
    @if (hasSaveFilePickerSupport) {
      <button
        type="button"
        class="menu-item"
        cdkMenuItem
        gaEvent="editor_save_as_file_picker"
        gaCategory="Editor"
        gaLabel="Botão de Salvar como - Ação Escolher um arquivo"
        (cdkMenuItemTriggered)="saveFileWithPicker()"
      >
        <svg-icon src="assets/mdi/content-save-move.svg" aria-hidden="true" />
        Escolher onde salvar…
      </button>
    }

    <button
      type="button"
      class="menu-item"
      cdkMenuItem
      gaEvent="editor_save_as_download"
      gaCategory="Editor"
      gaLabel="Botão de Salvar como - Ação Download"
      (cdkMenuItemTriggered)="saveFile()"
    >
      <svg-icon src="assets/mdi/download.svg" aria-hidden="true" />
      Baixar
    </button>

    <button
      type="button"
      class="menu-item"
      cdkMenuItem
      gaEvent="editor_save_as_download_portugol_studio"
      gaCategory="Editor"
      gaLabel="Botão de Salvar como - Ação Download para Portugol Studio"
      (cdkMenuItemTriggered)="saveFile(true)"
    >
      <svg-icon src="assets/lightbulb-sq.svg" aria-hidden="true" />
      Baixar para abrir no Portugol Studio
    </button>

    <button
      type="button"
      class="menu-item"
      cdkMenuItem
      gaEvent="editor_save_as_text"
      gaCategory="Editor"
      gaLabel="Botão de Salvar como - Ação Nova aba como texto"
      (cdkMenuItemTriggered)="saveFileManual('text')"
    >
      <svg-icon src="assets/mdi/file-document-outline.svg" aria-hidden="true" />
      Abrir numa aba do navegador, como texto
    </button>

    <button
      type="button"
      class="menu-item"
      cdkMenuItem
      gaEvent="editor_save_as_binary"
      gaCategory="Editor"
      gaLabel="Botão de Salvar como - Ação Nova aba como binário"
      (cdkMenuItemTriggered)="saveFileManual('binary')"
    >
      <svg-icon src="assets/mdi/file-download-outline.svg" aria-hidden="true" />
      Abrir numa aba do navegador, como binário
    </button>
  </div>
</ng-template>

<as-split
  #split
  direction="vertical"
  unit="pixel"
  gutterAriaLabel="Altura do painel"
  (dragEnd)="onSplitDragEnd($event)"
>
  <as-split-area size="*">
    <as-split
      direction="horizontal"
      class="thin-split"
      gutterAriaLabel="Código gerado"
      [gutterSize]="1"
      (dragEnd)="onGeneratedCodeDragEnd($event)"
    >
      <as-split-area class="code-editor-area" [size]="100">
        <ngx-monaco-editor
          [options]="codeEditorOptions"
          [ngModel]="code"
          (ngModelChange)="onCodeChange($event)"
          (init)="onEditorInit($event)"
        />
        @if (debugging && advancedDebugging) {
          <div
            class="debug-toolbar"
            role="toolbar"
            aria-label="Depuração"
            cdkDrag
            cdkDragBoundary=".code-editor-area"
            [cdkDragFreeDragPosition]="debugToolbarPosition()"
            (cdkDragEnded)="onDebugToolbarMoved($event)"
          >
            <button
              type="button"
              class="debug-toolbar-grip debug-toolbar-button"
              tabindex="-1"
              cdkDragHandle
              aria-label="Voltar a barra ao lugar inicial"
              appTooltip="Arrastar (dois cliques voltam ao lugar inicial)"
              appTooltipPosition="below"
              (click)="$event.detail === 0 && resetDebugToolbar()"
              (dblclick)="resetDebugToolbar()"
            >
              <svg-icon src="assets/mdi/drag-vertical.svg" aria-hidden="true" />
            </button>

            @let isPaused = paused();
            <button
              type="button"
              class="icon-btn debug-toolbar-button"
              tabindex="0"
              appTooltipShortcut="Alt+C"
              appTooltipPosition="below"
              aria-keyshortcuts="Alt+C"
              [appTooltip]="isPaused ? 'Continuar' : 'Pausar'"
              [attr.aria-label]="isPaused ? 'Continuar' : 'Pausar'"
              [attr.aria-disabled]="(!isPaused && executor.waitingForInput) || null"
              (click)="isPaused ? resumeDebugging('continue', 'editor') : pauseDebugging('editor')"
            >
              <svg-icon
                aria-hidden="true"
                [src]="isPaused ? 'assets/mdi/play.svg' : 'assets/mdi/pause.svg'"
                [class]="isPaused ? 'icon-green' : 'icon-yellow'"
              />
            </button>

            @for (button of stepButtons; track button.type) {
              <button
                type="button"
                class="icon-btn debug-toolbar-button"
                tabindex="-1"
                appTooltipPosition="below"
                [appTooltip]="button.label"
                [appTooltipShortcut]="button.shortcut"
                [attr.aria-label]="button.label"
                [attr.aria-keyshortcuts]="button.shortcut"
                [attr.aria-disabled]="!isPaused || null"
                (click)="resumeDebugging(button.type, 'editor')"
              >
                <svg-icon class="icon-blue" aria-hidden="true" [src]="button.icon" />
              </button>
            }

            <button
              type="button"
              class="icon-btn debug-toolbar-button"
              tabindex="-1"
              appTooltip="Parar"
              appTooltipShortcut="Shift+F5"
              appTooltipPosition="below"
              aria-label="Parar"
              aria-keyshortcuts="Shift+F5"
              (click)="stopCode('editor')"
            >
              <svg-icon src="assets/mdi/square-rounded-outline.svg" class="icon-red" aria-hidden="true" />
            </button>
          </div>
        }
      </as-split-area>

      <as-split-area [size]="0" [attr.inert]="generatedCodeOpen() ? null : ''">
        <ngx-monaco-editor [options]="generatedCodeEditorOptions" [(ngModel)]="executor.byteCode" />
      </as-split-area>
    </as-split>
  </as-split-area>

  <as-split-area [size]="outputSize" [minSize]="panelHeaderHeight">
    <section class="panel" aria-label="Painel">
      <header class="panel-header">
        <div class="panel-tabs" role="tablist" aria-label="Painel">
          <button
            type="button"
            role="tab"
            class="panel-tab"
            [id]="ids().outputTab"
            [attr.aria-controls]="ids().outputPanel"
            [attr.aria-selected]="panelView() === 'output'"
            [attr.tabindex]="panelView() === 'output' ? 0 : -1"
            (click)="selectPanelTab('output')"
            (keydown)="onPanelTabsKeydown($event)"
          >
            Saída
          </button>

          <button
            type="button"
            role="tab"
            class="panel-tab"
            [id]="ids().problemsTab"
            [attr.aria-controls]="ids().problemsPanel"
            [attr.aria-selected]="panelView() === 'problems'"
            [attr.tabindex]="panelView() === 'problems' ? 0 : -1"
            (click)="selectPanelTab('problems')"
            (keydown)="onPanelTabsKeydown($event)"
          >
            Problemas
            @if (problems().length > 0) {
              <span class="badge" aria-hidden="true">{{ problems().length }}</span>
            }
          </button>

          <button
            type="button"
            role="tab"
            class="panel-tab"
            [id]="ids().variablesTab"
            [attr.aria-controls]="ids().variablesPanel"
            [attr.aria-selected]="panelView() === 'variables'"
            [attr.tabindex]="panelView() === 'variables' ? 0 : -1"
            (click)="selectPanelTab('variables')"
            (keydown)="onPanelTabsKeydown($event)"
          >
            Variáveis
          </button>
        </div>

        <span class="panel-status" role="status">
          @if (paused()) {
            <span class="run-status paused" aria-hidden="true">
              <span class="dot"></span>Pausado na linha {{ debugPause()?.line }}
            </span>
          } @else if (executor.waitingForInput) {
            <span class="run-status waiting"><span class="dot"></span>Aguardando entrada</span>
          } @else if (executor.running && !stepInFlight()) {
            <span class="run-status running"><span class="dot"></span>Executando</span>
          }
        </span>

        <span class="panel-spacer"></span>

        @if (panelView() === "output") {
          <button
            type="button"
            class="icon-btn"
            aria-label="Limpar saída"
            appTooltip="Limpar saída"
            appTooltipPosition="above"
            [disabled]="!executor.stdOut || executor.running"
            (click)="clearOutput()"
          >
            <svg-icon src="assets/mdi/eraser.svg" aria-hidden="true" />
          </button>
        }

        <button
          type="button"
          class="icon-btn"
          appTooltipPosition="above"
          [attr.aria-label]="outputCollapsed ? 'Mostrar painel' : 'Recolher painel'"
          [attr.aria-expanded]="!outputCollapsed"
          [appTooltip]="outputCollapsed ? 'Mostrar painel' : 'Recolher painel'"
          (click)="toggleOutput()"
        >
          <svg-icon
            src="assets/mdi/chevron-up.svg"
            class="chevron"
            aria-hidden="true"
            [class.open]="!outputCollapsed"
          />
        </button>
      </header>

      <div
        class="panel-body"
        role="tabpanel"
        [id]="ids().outputPanel"
        [attr.aria-labelledby]="ids().outputTab"
        [hidden]="panelView() !== 'output'"
      >
        <ngx-monaco-editor
          class="output-editor"
          [options]="stdOutEditorOptions"
          [(ngModel)]="executor.stdOut"
          (init)="onStdOutEditorInit($event)"
        />

        @if (executor.waitingForInput && coarsePointer()) {
          <form class="output-input" (ngSubmit)="sendProgramInput()">
            <input
              #programInputField
              type="text"
              class="input"
              name="programInput"
              aria-label="Entrada do programa"
              placeholder="Digite e pressione Enter"
              autocomplete="off"
              enterkeyhint="send"
              [(ngModel)]="programInput"
            />
            <button type="submit" class="icon-btn" aria-label="Enviar entrada">
              <svg-icon src="assets/mdi/send.svg" class="icon-yellow" aria-hidden="true" />
            </button>
          </form>
        }
      </div>

      <div
        class="panel-body problems"
        role="tabpanel"
        [id]="ids().problemsPanel"
        [attr.aria-labelledby]="ids().problemsTab"
        [hidden]="panelView() !== 'problems'"
      >
        @if (problems().length === 0) {
          <p class="problems-empty">Nenhum problema encontrado no código.</p>
        } @else {
          <ul class="problems-list">
            @for (problem of problems(); track $index) {
              <li>
                <button type="button" class="problem" (click)="revealProblem(problem)">
                  <svg-icon
                    aria-hidden="true"
                    [class]="`problem-icon ${problem.severity}`"
                    [src]="problemIcons[problem.severity]"
                  />
                  <span class="visually-hidden">{{ severityLabels[problem.severity] }}:</span>
                  <span class="problem-message">{{ problem.message }}</span>
                  <span class="problem-location">linha {{ problem.line }}, coluna {{ problem.column }}</span>
                </button>
              </li>
            }
          </ul>
        }
      </div>

      <app-debug-variables
        class="panel-body"
        role="tabpanel"
        [id]="ids().variablesPanel"
        [attr.aria-labelledby]="ids().variablesTab"
        [hidden]="panelView() !== 'variables'"
        [pause]="debugPause()"
        [previousPause]="previousDebugPause()"
        [debugging]="debugging"
      />
    </section>
  </as-split-area>
</as-split>

<ng-template #shareToastTemplate let-toastRef>
  <div class="share-toast">
    <p class="share-toast-title">Link gerado</p>
    <a class="share-toast-link" target="_blank" rel="noopener" [href]="toastRef.data.url">{{ toastRef.data.url }}</a>
    <p class="share-toast-note">
      <svg-icon src="assets/mdi/clock-alert-outline.svg" class="icon-red" aria-hidden="true" />
      Este link expira em 90 dias.
    </p>
    <button type="button" class="btn btn-primary btn-sm" (click)="copyShareUrl(toastRef)">Copiar link</button>
  </div>
</ng-template>

<ng-template #debugTipIcon>
  <svg-icon src="assets/mdi/lightbulb-on-outline.svg" class="debug-tip-icon icon-yellow" aria-hidden="true" />
</ng-template>

<ng-template #debugTipTemplate let-toastRef>
  <div class="debug-tip-toast">
    <p class="debug-tip-toast-title">Dica: depuração avançada</p>
    <p>
      Nas configurações, a depuração avançada permite marcar pontos de parada no código e mostra também os botões
      Continuar, Pausar, Pular função e Sair da função.
    </p>
    <button type="button" class="btn btn-primary btn-sm" (click)="openAdvancedDebuggingSettings(toastRef)">
      Abrir configurações
    </button>
  </div>
</ng-template>
